import { Link } from 'react-router-dom';
import { siteDescription } from '@/mocks/site';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20soft%20minimalist%20abstract%20composition%20with%20warm%20golden%20and%20cream%20tones%2C%20geometric%20shapes%20blending%2C%20subtle%20Japanese%20and%20Korean%20aesthetic%20influence%2C%20elegant%20texture%2C%20soft%20gradients%2C%20artistic%20background%2C%20no%20text%2C%20clean%20design&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 text-background-50 text-sm mb-8">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-2-line text-accent-400"></i>
            </span>
            <span>日韩影视爱好者的中文字幕首选平台</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
            中文字幕 日韩
            <br />
            <span className="text-accent-400">让每一部日韩好片，都有中文相伴</span>
          </h1>

          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
            {siteDescription}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zuixin"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-flashlight-line"></i>
              </span>
              查看最新字幕
            </Link>
            <Link
              to="/category/jiaocheng"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium text-sm hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
              新手使用教程
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="animate-bounce w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}